import { render, staticRenderFns } from "./LogoMain.vue?vue&type=template&id=fd97a49a&scoped=true&lang=pug&"
import script from "./LogoMain.vue?vue&type=script&lang=js&"
export * from "./LogoMain.vue?vue&type=script&lang=js&"
import style0 from "./LogoMain.vue?vue&type=style&index=0&id=fd97a49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97a49a",
  null
  
)

export default component.exports